import React from 'react';

export const songsFaqsData = [
  {
    title: 'Can I do songs not listed?',
    content: (
      <p>
        Yes! You can upload or paste a link to any song you have rights to cover on the <a href="/app/generate">Swap Voice page</a> and swap the lead vocal to your voice. For release ready results you can also upload your own raw vocals and swap them to any voice or your own.
      </p>
    ),
  },
  {
    title: 'Where do these songs come from?',
    content: (
      <>
        <p>
          Most AI covers on social media have been created without permission from the original artists. Controlla is the first platform to ethically source and secure licenses for popular songs so you can AI cover them in your voice.
        </p>
        <p>
          We pay royalties to songwriters and singers involved with both the original and cover of a song so you can get copyright free AI music in your voice
        </p>
        <p>
          This results in the highest quality AI covers ever created and even allows you to release your tracks to streaming platforms so you can jam out to them alongside all your favorite music.
        </p>
      </>
    ),
  },
  {
    title: 'How can I release my song to Spotify?',
    content: (
      <p>
        Make sure to follow our guide for <a href="https://www.controlla.xyz/post/how-to-release-ai-covers-to-spotify-apple-music-and-all-streaming-platforms" target="_blank" rel="noopener noreferrer">Releasing AI Covers to Streaming</a> and check all the boxes for "This is a Cover Song" when distributing with platforms such as DistroKid. Personal Use licenses have a streaming cap of 50,000 streams (which can earn you back 40x the cost).
      </p>
    ),
  },
  {
    title: 'Can I sample or remix my AI cover?',
    content: (
      <p>
        You can sample and remix the songs in your voice however you like so long as you abide by cover song laws in your jurisdiction. Don't forget to check the box for "Cover Song" when distributing to streaming platforms. This ensures the original songwriters get paid per stream.
      </p>
    ),
  },
  {
    title: 'How long does it take to create a song?',
    content: (
      <p>
        If you've already created your voice, you can preview songs instantly and generate full versions in two clicks. Your final mixed song will be ready in your library within 5 - 10 minutes.
      </p>
    ),
  },
];
